import * as React from 'react';

interface PhotoFallbackProps {
  src?: string | { default: string, webp?: string },
  minWidth?: number,
}

export const PhotoMediaFallback = ({
  src,
  minWidth,
}: PhotoFallbackProps) => {

  if(!src) return <> </>;

  const media = `(min-width: ${minWidth}px)`;

  if (typeof src === 'string') {
    return <source media={media} srcSet={src} />;
  }

  return (
    <>
      <source media={media} srcSet={src.webp} type="image/webp" />
      <source media={media} srcSet={src.default} />
    </>
  );

};
